import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { CompanyLogo, UserInfo, Header } from '@ibinder/ui-common-core';
import { signout, user, home } from '@ibinder/common-icons';

import {
  TransparentActionButton,
  TransparentLinkButton,
  MenuRowWrapper,
  MenuRow,
  ProfileInformation
} from './Navbar.styles';

import { getAppSetting } from '../../../Shared/ApplicationSettings';

const NavbarLabels = {
  userProfile: 'User profile',
  logout: 'Log out'
};

export const Navbar = () => {
  const navigate = useNavigate();
  const [userName, setUserName] = useState(localStorage.getItem('userName'));
  const company = 'iBinder';
  const userPicture = localStorage.getItem('userPicture');
  const profileUrl = new URL(
    'userProfile/Profile',
    getAppSetting('REACT_APP_PUBLIC_URL')
  ).href;

  const onHomeClick = () => {
    navigate('/');
  };

  return (
    <Header
      image={
        company && (
          <Link to={'#'} onClick={onHomeClick}>
            <CompanyLogo company={company.toLowerCase()} withText={true} />
          </Link>
        )
      }
      icon={
        <TransparentLinkButton onClick={onHomeClick} to={`#`} type="button">
          {home}
        </TransparentLinkButton>
      }
    >
      <TransparentActionButton shouldCloseOnChildrenClick={true} icon={user}>
        <MenuRowWrapper flexDirection="column">
          <MenuRow useDefaultCursor={true}>
            <ProfileInformation>
              <UserInfo
                size="small"
                image={userPicture}
                fullName={userName}
                email={localStorage.getItem('userEmail')}
              />
            </ProfileInformation>
          </MenuRow>
          <a href={profileUrl}>
            <MenuRow>
              <span>{user}</span>
              <span>{NavbarLabels.userProfile}</span>
            </MenuRow>
          </a>
          <Link to={'/auth/logout'}>
            <MenuRow>
              {signout}
              <span>{NavbarLabels.logout}</span>
            </MenuRow>
          </Link>
        </MenuRowWrapper>
      </TransparentActionButton>
    </Header>
  );
};
